module.exports = __webpack_public_path__ + "img/ON150 Logo (Black).e45bd22a.jpg";